export const AIKOVIBE_GIFT_CARD_CODE = 'AIKOVIBEGIFT99'
export const STEAL50_COUPON_CODE = 'STEAL50'

const REDEEMABLE_RULES = {
  [AIKOVIBE_GIFT_CARD_CODE]: {
    code: AIKOVIBE_GIFT_CARD_CODE,
    kind: 'gift_card',
    tableName: 'gift_card_usages',
    codeColumn: 'gift_card_code',
    blockedMessage: 'This exclusive gift card can only be used once per customer!',
  },
  [STEAL50_COUPON_CODE]: {
    code: STEAL50_COUPON_CODE,
    kind: 'coupon',
    tableName: 'coupon_usages',
    codeColumn: 'coupon_code',
    blockedMessage: 'This exclusive discount can only be used once per customer!',
  },
}

export function normalizeRedeemableCode(value) {
  return String(value ?? '').trim().toUpperCase()
}

export function getRedeemableRule(code) {
  const normalizedCode = normalizeRedeemableCode(code)

  if (!normalizedCode) {
    return null
  }

  return REDEEMABLE_RULES[normalizedCode] ?? null
}

export function getRedeemableRuleMessage(code) {
  return getRedeemableRule(code)?.blockedMessage || ''
}

